import { SetFieldValueMutation } from '@app/graphql/service/schema'

export const useCheckSetFieldValueResponse = (response: SetFieldValueMutation): void => {
  if (response.channelV2.__typename === 'ChannelError') {
    throw new Error(response.channelV2.code)
  }

  if (response.channelV2.sessionV2.__typename === 'SessionError') {
    throw new Error(response.channelV2.sessionV2.code)
  }

  if (response.channelV2.sessionV2.setValue.setV2.__typename === 'ItemSetError') {
    throw new Error(response.channelV2.sessionV2.setValue.setV2.code)
  }
}
